@if (type === 'tag' && selectedBanner && selectedQuote && placement === exclusiveTabPlacements?.QuotesTag) {
<!-- Exclusive tariff tags -->
<div class="d-inline-flex ms-3 px-2 py-25 rounded-top" [ngStyle]="selectedBanner?.scriptSource"
  (click)="handlePopupClick($event)">
  @if (selectedBanner?.icons?.prefix){
  <img class="me-2 banner-img" [src]="selectedBanner?.icons?.prefix" alt="icon" />
  }

  <span class="fs-17 fw400 lh-1" [innerHTML]="bannerTemplate"></span>
</div>
}

@if (type === 'infoBar' && selectedBanner && selectedQuote) {
<!-- Info bar -->
@if (selectedBanner?.popup) {
<div class="my-3 px-2 py-25 rounded d-flex align-items-center" [ngStyle]="selectedBanner?.scriptSource"
  (click)="handlePopupClick($event)">
  @if (selectedBanner?.icons?.prefix){
  <img class="me-2 banner-img" [src]="selectedBanner?.icons?.prefix" alt="icon" />
  }

  <span class="fs-17 fw400 lh-1" [innerHTML]="bannerTemplate"></span>
</div>
} @else {
<div class="p-2 rounded-1 fw700" [ngStyle]="selectedBanner?.scriptSource">
  @if (selectedBanner?.icons?.prefix){
  <img class="me-2 banner-img" [src]="selectedBanner?.icons?.prefix" alt="icon" />
  }
  {{ selectedBanner?.content }}
</div>
}
}

<!-- Tool tip -->
@if (type === 'toolTip' && selectedBanner && selectedQuote) {
<div [ngStyle]="selectedBanner?.scriptSource">
  {{ selectedBanner?.content }}
</div>
}

<!-- App related info -->
@if (type === 'appInfo' && selectedBanner && selectedQuote) {
<div class="my-3 px-2 py-25 rounded d-flex align-items-center" [ngStyle]="selectedBanner?.scriptSource"
  (click)="handlePopupClick($event)">
  @if (selectedBanner?.icons?.prefix){
  <img class="me-2 banner-img" [src]="selectedBanner?.icons?.prefix" alt="icon" />
  }

  <span class="fs-17 fw400 lh-1" [innerHTML]="bannerTemplate"></span>
</div>
}

<!-- Tracker info -->
@if (type === 'trackerInfo' && selectedBanner && selectedQuote) {
<div class="d-flex align-items-center gap-3 px-4 mb-4">
  <div class="info-icon-container" (mouseenter)="showTrackerInfo = true" (mouseleave)="showTrackerInfo = false"
    (click)="toggleTrackerInfo()">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
      style="cursor: pointer;">
      <circle cx="12" cy="12" r="10" fill="#0066CC" stroke="#0066CC" stroke-width="2" />
      <text x="12" y="17" font-size="14" font-weight="bold" fill="white" text-anchor="middle">i</text>
    </svg>
  </div>

  <p class="m-0 fs-17">{{selectedBanner?.content}}</p>
</div>
}

<!-- important message -->
@if (type === 'importantMessage' && selectedBanner && selectedQuote) {
<div class="energy-price-cap-wrapper mb-4" [ngStyle]="selectedBanner?.scriptSource">
  <div class="icon-section">
    <svg class="info-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="2" />
      <path d="M12 7V8M12 11V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
  </div>
  <div class="d-lg-flex d-grid align-items-center gap-2">
    <div class="energy-price-cap fs-17" markdown [data]="selectedBanner?.content"></div>
  </div>
</div>
}